import React from 'react';
import { Field, FieldProps } from 'react-final-form';
import {
  createStyles,
  withStyles,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core';
import { Switch } from 'components/common';
import { SwitchProps as MUISwitchProps } from '@material-ui/core/Switch';

interface SwitchPropsInterface {
  inputProps?: MUISwitchProps;
}

const styles = (theme) =>
  createStyles({
    root: {
      margin: theme.spacing(2, 0),
    },
    label: {
      marginLeft: theme.spacing(1),
    },
  });

const SwitchField = ({
  classes,
  name,
  disabled,
  label,
  inputProps = {},
  fullWidth = true,
  ...rest
}: FieldProps<any, any> & SwitchPropsInterface) => (
  <Field
    type="checkbox"
    name={name}
    render={({ input: { name: inputName, onChange, value }, meta: { touched, error } }) => {
      const handleChange = (event) => {
        if (rest.onChange) {
          rest.onChange(event.target.checked);
        } else {
          onChange(event);
        }
      };

      return (
        <FormControl className={classes.root} fullWidth={fullWidth}>
          <FormControlLabel
            control={
              <Switch
                name={inputName}
                onChange={handleChange}
                checked={!!value}
                disabled={disabled}
                {...inputProps}
              />
            }
            label={label}
            classes={{ label: classes.label }}
          />
          {touched && error && <FormHelperText error>{error}</FormHelperText>}
        </FormControl>
      );
    }}
    {...rest}
  />
);

export default withStyles(styles)(SwitchField);
